<template>
    <center-mode v-if="mode === 'center'" :customize="customize"></center-mode>
    <right-mode v-else-if="mode === 'right'" :customize="customize"></right-mode>
</template>

<script>
    import CenterMode from './CenterMode';
    import RightMode from './RightMode';

    export default {
        name: 'KiafLoginView',
        components: {
            CenterMode,
            RightMode
        },
        props: {
            mode: {
                type: String,
                default: 'center'
            },
            customize: {
                type: Object,
                default() {
                    return {};
                }
            }
        }
    };
</script>
